import { createFileRoute } from '@tanstack/react-router';
import { StaffingSkillLevelsPage } from '@/pages/staffing/StaffingSkillLevelsPage';

export const Route = createFileRoute('/_authenticated/_app/staffing/skill-levels')({
	component: StaffingSkillLevelsPage,
});
